class CartRemoveButton2 extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.closest("cart-notification").deleteQuantity(this.dataset.index, 0);
      this.closest(".cart-notification-product").classList.add("loading");
      this.closest(
        ".cart-notification-product"
      ).firstElementChild.classList.remove("hidden");
      document.getElementById('mini-cart').classList.add('loading-bar');
    });
  }
}
customElements.define("cart-remove-button-2", CartRemoveButton2);

class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById("mini-cart");
    this.cartItemConatiner = document.getElementById(
      "cart-notification-product"
    );
 
    this.emptyCartItem = document.getElementById("min-cart-items");
    this.emptyCartItem2 = document.getElementById("min-cart-items-2");
    this.cartItemMessageShow = document.querySelector(".empty-cart-item");
    this.emptyCartButtonDisable = document.getElementById("empty-cart-button");
    this.emptyCartButtonDisable2 = document.getElementById("empty-cart-button-2");
    // this.emptyCartHeader =  document.querySelector(".cart-notification-header"); 

    // this.cartAddSuccess = document.querySelector(".item-success-message ");
    // this.cartEmptyHead = document.querySelector(".item-empty-message");

    this.header = document.querySelector("sticky-header");
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );

    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener("click", this.close.bind(this))
    );

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener("change", this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    if (!event.target.closest("select")) {
      this.updateQuantity(
        event.target.dataset.index,
        event.target.value,
        document.activeElement.getAttribute("name")
      );
      document
        .querySelector(".cart-overlay")
        .classList.add("active");
    }
  }

  open() {
    this.notification.classList.add("animate", "active");
    document.querySelector("body").classList.add("added__overlay");

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener("click", this.onBodyClick);
  }

  close() {
    document.getElementById("mini-cart").classList.remove("active");
    document.querySelector("body").classList.remove("added__overlay");

    document.body.removeEventListener("click", this.onBodyClick);

  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section) => {
      let renderSelector = document.getElementById(section.id);
      if (renderSelector) {
        renderSelector.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id]
        );
      }
    });

    let cartItemCount = parseInt(
      this.getSectionInnerHTML(parsedState.sections["cart-notification-count"])
    );

    //console.log(cartItemCount);

    if (cartItemCount == 0) {
      this.emptyCartItem.classList.add("no-js-inline");
      this.emptyCartItem2.classList.remove("no-js-inline");
      this.emptyCartButtonDisable.classList.add("no-js-inline");
      this.emptyCartButtonDisable2.classList.remove("no-js-inline");
      this.cartItemMessageShow.classList.remove("no-js-inline");
      // this.cartAddSuccess.classList.add("no-js-inline");
      // this.cartEmptyHead.classList.add("no-js-inline");
      //  this.emptyCartHeader.classList.add('empty-cart');
    } else {
      this.emptyCartItem.classList.remove("no-js-inline");
      this.emptyCartItem2.classList.add("no-js-inline");
      this.emptyCartButtonDisable.classList.remove("no-js-inline");
      this.emptyCartButtonDisable2.classList.add("no-js-inline");
      this.cartItemMessageShow.classList.add("no-js-inline");
      // this.cartAddSuccess.classList.remove("no-js-inline");
      // this.cartEmptyHead.classList.remove("no-js-inline");
      // this.emptyCartHeader.classList.remove('empty-cart');
    }

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-notification-product",
      },
      {
        id: "cart-notification-subtotal",
      },
      {
        id: "cart-notification-count",
      },
      {
        id: "cart-notification-discount"
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        let parsedState = JSON.parse(state);
        this.renderContents(parsedState);
        if (parsedState.item_count > 0) {
          this.updateLiveRegions(line, parsedState.item_count);
        }
      })
      .catch(() => {
        console.error(e);
      })
      .finally(() => {
        document
          .querySelector(".cart-overlay")
          .classList.remove("active");
		 this.notification.classList.remove('loading-bar');
      });
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.json();
      })
      .then((state) => {
          var Itemcount = document.querySelector('.cart-notification-count-item-cart');
          Itemcount.textContent = state.item_count;
          
          var currentVal = state.total_price;
          // var targetVal = 150000;
          var progressBar = document.querySelector('.cart-shipping-progress');
          var progressNum = document.querySelector('.cart-shipping-num');
          var progressOuter = document.querySelector('.cart-shipping-num-inner');
          var successMsg = document.querySelector('.cart-shipping-success');

          var targetVal = document.getElementById("price-free").getAttribute('data-price-free');
          
          var result = Math.round(100 * currentVal / targetVal);
          // progressBar.forEach(function(el){
          //   el.setAttribute('style', "width: ".concat(result, "%"));
          // })

          progressBar.setAttribute('style', "width: ".concat(result, "%"));

          var newProgressNum = (targetVal - currentVal) / 100;
          if(targetVal <= currentVal){
            successMsg.style.display = 'flex';
            progressOuter.style.display = 'none';
            progressNum.textContent = newProgressNum;

            // successMsg.forEach(function(el){
            //   el.style.display = 'flex';
            // });
            // progressOuter.forEach(function(el){
            //   el.style.display = 'none';
            // });
            // progressNum.forEach(function(el){
            //   el.textContent = newProgressNum;
            // });
          } else {
            successMsg.style.display = 'none';
            progressOuter.style.display = 'flex';
            progressNum.textContent = newProgressNum;
            // successMsg.forEach(function(el){
            //   el.style.display = 'none';
            // });
            // progressOuter.forEach(function(el){
            //   el.style.display = 'flex';
            // });
            // progressNum.forEach(function(el){
            //   el.textContent = newProgressNum;
            // });
          }
      })
  }
  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document
        .getElementById(`Line-item-error-${line}`)
        .querySelector(".cart-item-error-text").innerHTML =
        window.cartStrings.quantityError.replace(
          "[quantity]",
          document.getElementById(`Quantity-${line}`).value
        );
      document
        .getElementById(`Line-item-error-${line}`)
        .classList.remove("no-js-inline");
    } else {
      document
        .getElementById(`Line-item-error-${line}`)
        .classList.add("no-js-inline");
    }
    this.currentItemCount = itemCount;
  }

  deleteQuantity(line, quantity, name) {
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        let parsedState = JSON.parse(state);
        this.renderContents(parsedState);
      })
      .catch(() => {
        console.error(e);
      })
      .finally(() => {
        document
          .querySelector(".cart-overlay")
          .classList.remove("active");
		this.notification.classList.remove('loading-bar');
      });
    
      fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.json();
      })
      .then((state) => {
          var Itemcount = document.querySelector('.cart-notification-count-item-cart');
          Itemcount.textContent = state.item_count;

          var currentVal = state.total_price;
          // var targetVal = 150000;
          var progressBar = document.querySelector('.cart-shipping-progress');
          var progressNum = document.querySelector('.cart-shipping-num');
          var progressOuter = document.querySelector('.cart-shipping-num-inner');
          var successMsg = document.querySelector('.cart-shipping-success');
          var targetVal = document.getElementById("price-free").getAttribute('data-price-free');
          

          var result = Math.round(100 * currentVal / targetVal);
          // progressBar.forEach(function(el){
          //   el.setAttribute('style', "width: ".concat(result, "%"));
          // })

          progressBar.setAttribute('style', "width: ".concat(result, "%"));

          var newProgressNum = (targetVal - currentVal) / 100;
          console.log(newProgressNum);
          if(targetVal <= currentVal){
            successMsg.style.display = 'flex';
            progressOuter.style.display = 'none';
            progressNum.textContent = newProgressNum;

            // successMsg.forEach(function(el){
            //   el.style.display = 'flex';
            // });
            // progressOuter.forEach(function(el){
            //   el.style.display = 'none';
            // });
            // progressNum.forEach(function(el){
            //   el.textContent = newProgressNum;
            // });
          } else {
            successMsg.style.display = 'none';
            progressOuter.style.display = 'flex';
            progressNum.textContent = newProgressNum;
            // successMsg.forEach(function(el){
            //   el.style.display = 'none';
            // });
            // progressOuter.forEach(function(el){
            //   el.style.display = 'flex';
            // });
            // progressNum.forEach(function(el){
            //   el.textContent = newProgressNum;
            // });
          }
      })
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (
      target !== this.notification &&
      !target.closest("cart-notification") &&
      !target.closest("#quickViewWrapper")
    ) {
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-notification", CartNotification);

class OpenMiniCart extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.onClickMiniCart();
    });

    this.notification = document.getElementById("mini-cart");
    this.onBodyClassRemove = this.handleBodyClass.bind(this);

    this.notification.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.miniCartClose()
    );
  }

  onClickMiniCart() {
    document
      .getElementById("mini-cart")
      .classList.add("animate", "active");
    document.querySelector("body").classList.add("added__overlay");

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener("click", this.onBodyClassRemove);
  }

  miniCartClose() {
    document.getElementById("mini-cart").classList.remove("active");
    document.querySelector("body").classList.remove("added__overlay");

    document.body.removeEventListener("click", this.onBodyClassRemove);
    removeTrapFocus(document.querySelector(".header__actions_btn--cart"));
  }

  handleBodyClass(evt) {
    let eventTarget = evt.target;
    //console.log(eventTarget);
    if (
      !eventTarget.closest("cart-notification") &&
      !eventTarget.closest("open-minicart") &&
      !eventTarget.closest("button")
    ) {
      this.miniCartClose();
    }
  }
}
customElements.define("open-minicart", OpenMiniCart);
